module.exports = "<button class=\"tab\"\r\n        ng-class=\"{active: $ctrl.isActive}\"\r\n        ng-click=\"$ctrl.onSelect({tab: $ctrl.activeTabId})\"\r\n        ng-cloak>{{ ::$ctrl.headerText }}\r\n</button>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/utils/tab/components/tab-header/tab-header.html
// module id = 2084
// module chunks = 0